module.exports = __webpack_public_path__ + "img/failure.b900b50a.png";